export type SleepioWellnessOnboardingStep =
  'ConfirmDetails' |
  'CreatePassword' |
  'ReadyToStartSleepioWellness' |
  'CoverageRejection' |
  'PasswordNotSetError' |
  'ExpiredLinkError';

export interface Action {
  type: 'SET_STEP';
  step: SleepioWellnessOnboardingStep;
}

export interface SleepioWellnessOnboardingState {
  step: SleepioWellnessOnboardingStep;
  action: Action;
}

export const initialState: SleepioWellnessOnboardingState = {
  step: 'ConfirmDetails',
  action: {
    type: 'SET_STEP',
    step: 'ConfirmDetails',
  },
};

const reducer = (state: SleepioWellnessOnboardingState, action: Action) => {
  switch (action.type) {
  case 'SET_STEP':
    return {
      ...state,
      step: action.step,
    };
  default:
    return state;
  }
};

export default reducer;
